import { render, staticRenderFns } from "./RedirectorView.vue?vue&type=template&id=29718d0a"
import script from "./RedirectorView.vue?vue&type=script&lang=js"
export * from "./RedirectorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports